import { render, staticRenderFns } from "./BatchOrder.vue?vue&type=template&id=b89eb4c4&scoped=true&"
import script from "./BatchOrder.vue?vue&type=script&lang=js&"
export * from "./BatchOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b89eb4c4",
  null
  
)

export default component.exports